<script setup>
defineProps({
  view: {
    type: String,
    required: true
  }
})
</script>

<template>
  <h4 class="modal-title lg:text-xl xl:text-2xl">
    <span v-if="view === 'signup'" class="font-semibold lg:text-2xl">Créez un compte gratuitement</span>
    <span v-if="view === 'login'" class="font-semibold lg:text-2xl">Connectez-vous</span>
    <br />
    pour accéder à toute
    <br />
    la plateforme
  </h4>
</template>
